import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "px-6 py-2"
};
const _hoisted_2 = {
  class: "table",
  id: "task-table"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "fa fa-check"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
  const _component_main_header = _resolveComponent("main-header");
  const _component_LlSecondaryButton = _resolveComponent("LlSecondaryButton");
  const _component_LlCheckbox = _resolveComponent("LlCheckbox");
  const _component_practice_area_edit = _resolveComponent("practice-area-edit");
  return _openBlock(), _createElementBlock(_Fragment, null, [$data.loading ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
    key: 0,
    type: "heading,table-row-divider,table"
  })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_main_header, {
    content: "Practice Areas"
  }), _createElementVNode("p", null, _toDisplayString($data.me.terms.Matter) + "s can be assigned to a practice area for reporting purposes. ", 1), _withDirectives(_createElementVNode("table", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", null, "Name"), _createElementVNode("th", null, "Matters"), _createElementVNode("th", null, "Default")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.mattertags, t => {
    return _openBlock(), _createElementBlock("tr", {
      key: t.label,
      onClick: $event => $options.editMatterTag(t),
      class: _normalizeClass({
        'bg-gray-200 transition transform duration-1000 ease-in-out': t.active
      })
    }, [_createElementVNode("td", null, _toDisplayString(t.label), 1), _createElementVNode("td", null, _toDisplayString(t.matterCount), 1), _createElementVNode("td", null, [_withDirectives(_createElementVNode("span", _hoisted_4, null, 512), [[_vShow, t.default]])])], 10, _hoisted_3);
  }), 128))])], 512), [[_vShow, $data.mattertags.length > 0]]), _createVNode(_component_LlSecondaryButton, {
    color: "primary",
    "data-cy": "create-matter-tag",
    onClick: $options.editMatterTag
  }, {
    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" Create ", -1)]))]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_LlCheckbox, {
    class: "pt-5",
    modelValue: $data.requireMatterTag,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.requireMatterTag = $event),
    label: `Require setting Practice Area on all ${$data.me.terms.matter}s`,
    onCheckboxClick: $options.settingsUpdate
  }, null, 8, ["modelValue", "label", "onCheckboxClick"])])), _createVNode(_component_practice_area_edit, {
    modelValue: $data.showEditDialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.showEditDialog = $event),
    tag: $data.selectedTag,
    "all-tags": $data.mattertags,
    "lean-law-api": $props.leanLawApi,
    alerts: $props.alerts,
    onSave: $options.handleSave,
    onDelete: $options.handleDelete,
    onCancel: $options.handleCancel
  }, null, 8, ["modelValue", "tag", "all-tags", "lean-law-api", "alerts", "onSave", "onDelete", "onCancel"])], 64);
}